import { render, staticRenderFns } from "./SysApiMockModal.vue?vue&type=template&id=4f04b455&"
import script from "./SysApiMockModal.vue?vue&type=script&lang=js&"
export * from "./SysApiMockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports